import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { useCreateTicket, useMaterials } from '@hooks'
import { useUser } from '@contexts'
import { CommonTicketForm } from '@types'

import { Camion } from './Camion'
import { Materials } from './Materials'
import { Origen } from './Origen'
import { validationSchema, FormValidation } from './validations/validations'
import { NuevaSolicitud } from './NuevaSolicitud'

export const NewTicketForm = () => {
  const { state: userState } = useUser()
  const { createTicket } = useCreateTicket()
  const [step, setStep] = useState(1)
  const { materials } = useMaterials()
  const navigate = useNavigate()
  const { control, reset, handleSubmit } = useForm<FormValidation>({
    resolver: yupResolver(validationSchema),
  })

  const nextStep = () => {
    setStep(step + 1)
  }

  const prevStep = () => {
    setStep(step - 1)
  }

  const handleReturn = () => {
    navigate('/dashboard/suppliers')
  }

  const submitHandler = (form: CommonTicketForm) => {
    createTicket(form)
    reset()
    navigate('/dashboard/suppliers')
  }

  switch (step) {
    case 0:
      handleReturn()
      break
    case 1:
      return (
        <>
          <NuevaSolicitud prevStep={prevStep} />
          <Materials nextStep={nextStep} materialOptions={materials} control={control} />
        </>
      )
    case 2:
      return (
        <>
          <NuevaSolicitud prevStep={prevStep} />
          <Camion nextStep={nextStep} prevStep={prevStep} control={control} />
        </>
      )
    case 3:
      return (
        <>
          <NuevaSolicitud prevStep={prevStep} />
          <Origen
            control={control}
            userState={userState}
            handleNewTicket={submitHandler}
            handleSubmit={handleSubmit}
          />
        </>
      )
    default:
      break
  }
  return <></>
}
